import { Box, Button } from "@mui/material";
import { useCallback, useState } from "react";
import { useChatStore } from "src/views/assistant/stores/ChatStore";
import FolderIcon from "@mui/icons-material/Folder";
import DatasetSelectorModal from "src/reusable/Chat/PromptInput/DatasetSelectorModal";
import type { Dataset as ArtifactSelectorDataset } from "src/reusable/Chat/PromptInput/ArtifactSelectorModal";

const ReferenceDatasetSelector = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const { dropdownDatasets: rfpDatasets, setDropdownDatasets: setRfpDatasets } =
    useChatStore();

  const handleConfirm = useCallback(
    (datasets: ArtifactSelectorDataset[]) => {
      setRfpDatasets(datasets);
    },
    [setRfpDatasets],
  );

  return (
    <Box>
      <Button
        variant="outlined"
        startIcon={<FolderIcon />}
        onClick={() => setIsModalOpen(true)}
        sx={{ textTransform: "none" }}
        data-attr="proposal-gen:btn:select-reference-datasets"
        data-testid="propgen-btn-select-datasets"
      >
        Select Dataset{rfpDatasets.length === 1 ? "" : "s"}
        {rfpDatasets.length > 0 ? ` (${rfpDatasets.length})` : ""}
      </Button>

      <DatasetSelectorModal
        open={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        onConfirm={handleConfirm}
        defaultSelectedDatasets={rfpDatasets}
      />
    </Box>
  );
};

export default ReferenceDatasetSelector;
